export const config = {
  APP_VERSION: process.env.REACT_APP_VERSION,
}
